export const title = (p5, trait, width, yurtTrait) => {
  const margin = 50;
  p5.push();
  p5.textStyle(p5.BOLD);
  p5.translate(width / 2 - margin * 7, yurtTrait.h + 30);
  p5.textSize(140 / trait.pixels);
  p5.text(yurtTrait.kitName, 0, 0);
  p5.translate(0, -margin * 1.2);
  p5.textSize(150 / trait.pixels);
  let typeText = "STANDARD";

  if (trait.windows > 0 && trait.doors > 0) {
    typeText = "W&D";
  } else if (trait.doors > 0) {
    typeText = "DOOR";
  } else if (trait.windows > 0) {
    typeText = "WINDOW";
  } else if (trait.frenchDoor === "left") {
    typeText = "FD LEFT";
  } else if (trait.frenchDoor === "center") {
    typeText = "FD CENTER";
  } else if (trait.frenchDoor === "right") {
    typeText = "FD RIGHT";
  }

  p5.text(typeText, 0, 0);

  p5.translate(0, -margin);

  p5.text(`${yurtTrait.h / trait.pixels / 12} ft`, 0, 0);

  p5.translate(0, -margin * (p5.textWidth(trait.notes) / 300) - margin);
  p5.textSize(120 / trait.pixels);
  p5.textStyle(p5.BOLD);
  p5.fill("red");
  p5.text(trait.notes, 0, 0, 170, 500);

  p5.translate(0, -margin * (p5.textWidth(yurtTrait.allNotes) / 400) - margin);
  p5.textSize(120 / trait.pixels);
  p5.textStyle(p5.BOLD);
  p5.fill("red");
  p5.text(yurtTrait.allNotes, 0, 0, 170, 500);

  p5.pop();
  p5.push();
  p5.translate(width / 2 - margin * 6, margin);
  p5.ellipseMode(p5.CENTER);
  p5.noFill();
  p5.stroke("red");
  p5.ellipse(0, 0, 15 * trait.pixels);
  p5.fill("red");
  p5.stroke("red");
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(300 / trait.pixels);
  p5.text(trait.id + 1, 0, 0);
  p5.pop();

  if (trait.frenchDoor) {
    p5.push();
    p5.translate(width / 2 + trait.w * 0.75, yurtTrait.h / 2);
    p5.textSize(20);
    p5.textStyle(p5.BOLD);
    p5.text(`width: ${trait.frenchW}`, 0, 0);
    p5.pop();
  }

  const checklist = ["RAFTER PLATE", "BIRD BLOCKS"];

  if (trait.eaves) {
    checklist.push("EAVES");
  }

  checklist.push("CORNER TRIM");

  if (trait.windows) {
    checklist.push("WINDOW EDGE TRIM");
  }

  for (let i = 0; i < checklist.length; i++) {
    p5.push();
    p5.translate(width / 2 + trait.w * 0.75, yurtTrait.h + 30 - margin * i);
    p5.strokeWeight(1);
    p5.stroke("red");
    p5.rect(0, 0, 3 * trait.pixels, -3 * trait.pixels);
    p5.noStroke();
    p5.textSize(width / 12 / trait.pixels);
    p5.fill("red");
    p5.textStyle(p5.BOLD);
    p5.text(checklist[i], 3 * trait.pixels * 2, -(3 * trait.pixels) / 4);
    p5.pop();
  }
};
